import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col-reverse md:flex-row flex-wrap gap-2 justify-between py-8 px-2"
}
const _hoisted_2 = { class: "flex flex-wrap gap-2 md:gap-4" }
const _hoisted_3 = { class: "flex items-center justify-center gap-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "px-1 py-3" }, /*#__PURE__*/_toDisplayString("Filtrar: "), -1)
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CardActivity = _resolveComponent("CardActivity")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_EmptyData = _resolveComponent("EmptyData")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.loading.activities
    }, null, 8, ["loader"]),
    (!_ctx.loading.activities)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_v_icon, {
                name: "bi-filter",
                scale: "1.2"
              }),
              _hoisted_4
            ]),
            _createVNode(_component_Dropdown, {
              options: _ctx.listCourses,
              placeholder: "Selecione Curso",
              modelValue: _ctx.selectedCourse,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCourse) = $event)),
              optionLabel: "name",
              optionValue: "id",
              loading: _ctx.loading.courses,
              emptyMessage: 
            _ctx.$t('labels.generic', {
              en: 'No course associated',
              pt: 'Nenhum curso associado',
            })
          ,
              emptyFilterMessage: 
            _ctx.$t('labels.generic', {
              en: 'No course found',
              pt: 'Nenhum curso encontrado',
            })
          ,
              filter: "",
              showClear: _ctx.selectedCourse!&&true,
              class: "w-full md:w-auto",
              onFilter: _ctx.onFilterCourse,
              disabled: _ctx.loading.courses
            }, null, 8, ["options", "modelValue", "loading", "emptyMessage", "emptyFilterMessage", "showClear", "onFilter", "disabled"]),
            _createVNode(_component_Dropdown, {
              options: _ctx.listClasses,
              placeholder: "Selecionar Turma",
              modelValue: _ctx.selectedClass,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedClass) = $event)),
              optionLabel: "name",
              optionValue: "id",
              loading: _ctx.loading.classes,
              emptyMessage: 
            _ctx.$t('labels.generic', {
              en: 'No class associated',
              pt: 'Nenhuma turma associada',
            })
          ,
              emptyFilterMessage: 
            _ctx.$t('labels.generic', {
              en: 'No class found',
              pt: 'Nenhuma turma encontrada',
            })
          ,
              filter: "",
              showClear: _ctx.selectedClass!&&true,
              class: "w-full md:w-auto",
              onFilter: _ctx.onFilterClass,
              disabled: !_ctx.selectedCourse
            }, null, 8, ["options", "modelValue", "loading", "emptyMessage", "emptyFilterMessage", "showClear", "onFilter", "disabled"])
          ]),
          _createVNode(_component_Button, {
            label: "Nova Atividade",
            class: "btn-primary w-full md:w-auto",
            icon: "pi pi-plus",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.addActivity()), ["prevent"]))
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Loader, {
      loader: _ctx.loading.activities
    }, null, 8, ["loader"]),
    (_ctx.studentActivities?.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.studentActivities, (activity, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_CardActivity, {
                activityId: activity?.activityId,
                students: activity?.students,
                completed: activity?.completed,
                feedback: activity?.feedback,
                title: activity?.title,
                onOnGoTo: _cache[3] || (_cache[3] = (e) => _ctx.goToCorrection(e))
              }, null, 8, ["activityId", "students", "completed", "feedback", "title"])
            ]))
          }), 128)),
          (_ctx.activityParams?.total!>_ctx.activityParams.size)
            ? (_openBlock(), _createBlock(_component_Paginator, {
                key: 0,
                rows: _ctx.activityParams.size,
                totalRecords: _ctx.activityParams.total,
                onPage: _ctx.paginateActivities
              }, null, 8, ["rows", "totalRecords", "onPage"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_EmptyData, {
      data: _ctx.studentActivities?.length === 0,
      label: _ctx.emptyStateActivities.description,
      image: _ctx.emptyStateActivities.image,
      imgSize: "h-40 md:h-64 mt-20",
      msgSize: "md:w-3/12"
    }, null, 8, ["data", "label", "image"])
  ]))
}